export default {
    sendPhoneCode: '/Api/Index/sendPhoneCode', // 发送验证码
    setPwd: '/Api/Index/setPwd', // 注册或修改密码
    login: '/Api/Index/login', // 登录

    allColumn: '/Api/index/allColumn', // 保险资讯分类信息
    columnArticle: '/Api/index/columnArticle', // 保险资讯文章列表

    getTopnews: '/Api/index/getTopnews', // 获取文章详情

    loginImg: '/Api/Index/getVerify/type/login', // 获取登录验证码图片
    registerImg: '/Api/Index/getVerify/type/register', // 获取注册验证码图片

    getCompanyList: 'Api/index/getCompanyList', // 获取保险公司
    getCompanyGoods: 'Api/index/getCompanyGoods/id/', // 获取对应彩铃
}


// WEBPACK FOOTER //
// ./src/base/js/api.js